import billingItemService from '../services/billingItem.service';

const billings = {
    namespaced: true,
    state: {
        medediStatuses: null,
        localStatuses: null,
        medediPlacesOfService: null,
    },
    actions: {
        //CREATE
        create(_, model) {
            return billingItemService.create(model);
        },

        //READ
        getBillingItemLink(_, id) {
            return billingItemService.getBillingItemLink(id);
        },
        
        checkStatus(_, id) {
            return billingItemService.checkStatus(id);
        },
        
        convertToAccount(_, id) {
            return billingItemService.convertToAccount(id);
        },

        async getMedediStatuses({commit, state, getters}) {
            if (state.medediStatuses === null) {
                var response = await billingItemService.getMedediStatuses();
                commit('setMedediStatuses', response);
            }
            return getters.medediStatuses;
        },

        async getLocalStatuses({commit, state, getters}) {
            if (state.localStatuses === null) {
                var response = await billingItemService.getLocalStatuses();
                commit('setLocalStatuses', response);
            }
            return getters.localStatuses;
        },

        async getMedediPlacesOfService({commit, state, getters}) {
            if (state.medediPlacesOfService === null) {
                var response = await billingItemService.getMedediPlacesOfService();
                commit('setMedediPlacesOfService', response);
            }
            return getters.medediPlacesOfService;
        },

        //UPDATE
        update(_, model) {
            return billingItemService.update(model);
        },

        //DELETE
        delete(_, id) {
            return billingItemService.delete(id);
        },
    },
    getters: {
        medediStatuses: (state) => state.medediStatuses,
        localStatuses: (state) => state.localStatuses,
        medediPlacesOfService: (state) => state.medediPlacesOfService,
    },
    mutations: {
        setMedediStatuses(state, types) {
            state.medediStatuses = types;
        },
        setLocalStatuses(state, types) {
            state.localStatuses = types;
        },
        setMedediPlacesOfService(state, types) {
            state.medediPlacesOfService = types;
        },
    },
};

export default billings;
